<template>
<div class='main'>
 <background-vue></background-vue>
    <el-row type="flex"  justify="center" class='forgetPass'>
        <el-col :span="12" class='deatail_content'> 
            <el-row class='content_cc'>
                <el-col :span="24" class='crumbs'>
                    您的位置：<a href="#">江苏省音乐家协会</a> > 我要注册
                </el-col>
                <el-col :span="24" class='member_out'>
                    <p class='title'>忘记密码</p>
                    <el-form  class="ruleForm" >
                        <div class='formCon '>
                            <el-form-item class='form_cc'>
                                <div class='form_icon'>
                                    <i class='icon iconemail'></i> 
                                </div>
                                <el-input class='inpStyle' placeholder="你的邮箱/手机"></el-input>
                            </el-form-item>
                            <el-form-item prop="code" class='form_cc'>
                                <div class='form_icon'>
                                    <i class='icon iconverifi'></i> 
                                </div>
                                <el-input  style='text-align:left;' class='inpStyle inputCode' placeholder="验证码"></el-input>
                                <!-- <el-button class="code" @click="createCode" v-model="checkCode"></el-button> -->
                                <input type="button" @click="createCode" v-model="checkCode" class="code">
                            </el-form-item>
                        </div>   
                        <el-form-item>
                            <button class='loginBtn'>提交</button>
                        </el-form-item>
                        <div class='loginDea'>
                            <a @click='()=>{this.$router.push({name:"userForget"})}' class='cor' style="vertical-align:middle;" >提供会员的账号及身份证也可以找回密码&nbsp;
                                <i class='icon iconarrow'></i>
                            </a>
                        </div>             
                    </el-form> 
                </el-col>
            </el-row>
        </el-col>
    </el-row>
     <p class='box_footer'>省音协考级报名咨询电话  025-83572077</p>
</div>
</template>
<script>
import backgroundVue from '@/components/Background.vue'
export default {
     components: {
     backgroundVue
  },
    data(){
        return {
           
           
           checkCode:'' 
        }
    },
    created(){
      this.createCode()
    },
    methods:{
            createCode(){
                //先清空验证码的输入
                this.code = "";
                this.checkCode = "";
                this.picLyanzhengma = "";
                //验证码的长度  
                var codeLength = 4; 
                //随机数 
                var random = new Array(0,1,2,3,4,5,6,7,8,9,'A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z');  
                for(var i = 0; i < codeLength; i++) {
                    //取得随机数的索引（0~35）
                    var index = Math.floor(Math.random()*36);   
                    //根据索引取得随机数加到code上
                    this.code += random[index];   
                }
                //把code值赋给验证码  
                this.checkCode = this.code; 
            }
  }
}
</script>
<style lang="less">
@import '../../static/less/forgetPassword.less';
</style>


// WEBPACK FOOTER //
// src/views/ForgetPassword.vue